import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import RequestsTPAsList from '@/views/companyPayments/requestTPA/TPAsList'
import BaiPagaMerchant from '@/views/companyPayments/BaiPagaMerchant'
import RequestsTPABAI from '@/views/companyPayments/requestTPA/BAI'
import TPARequestsList from '@/views/companyPayments/TPARequestsList'

export default [{
	path: routeList.COMPANY_PAYMENTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.COMPANY_PAYMENTS_REQUEST_TPA_PATH,
	name: routeList.COMPANY_PAYMENTS_REQUEST_TPA_NAME,
	props: true,
	component: RequestsTPAsList
},
{
	path: routeList.COMPANY_PAYMENTS_REQUEST_TPA_BAI_PATH,
	name: routeList.COMPANY_PAYMENTS_REQUEST_TPA_BAI_NAME,
	props: true,
	component: RequestsTPABAI,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.COMPANY_PAYMENTS_REQUEST_TPA_NAME)
	}
}, {
	path: routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_PATH,
	name: routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_NAME,
	props: true,
	component: BaiPagaMerchant
}, {
	path: routeList.COMPANY_PAYMENTS_TPA_REQUESTS_LIST_PATH,
	name: routeList.COMPANY_PAYMENTS_TPA_REQUESTS_LIST_NAME,
	component: TPARequestsList
}]
